<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Message</p>
      <button class="delete" aria-label="close" @click="$emit('close')"></button>
    </header>
    <section v-if="raw" class="modal-card-body error_content">
      <textarea rows="20" cols="40" style="border:none;" readonly>
        {{ parseLineFeeds(message) }}
      </textarea>
    </section>
    <section v-else v-html="formatMessage(message)" class="modal-card-body error_content"></section>
    <footer class="modal-card-foot">
      <button class="button flex-pulled-right" @click="$emit('close')">Close</button>
    </footer>
  </div>
</template>

<script>
import { parseLineFeeds } from '../utils'

export default {
  name: 'MessageModal',
  props: {
    message: null,
    raw: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    buildMsgListFromObject: function (object) {
      return Object.keys(object).map(attr => {
        if (typeof object[attr] === 'string') {
          return `<div><p>${attr}: ${object[attr]}</p></div>`
        } else if (object[attr] instanceof Array) {
          return `<ul><p>${attr}:</p>${object[attr].map((message, index) => {
            if (typeof message === 'string') {
              return `<li>  &bullet; ${message}</li>`
            } else {
              return `<ul><p>Item ${index + 1}:</p>${this.buildMsgListFromObject(message)}</ul>`
            }
          }).join('<br>')}</ul>`
        } else {
          return `<ul><li>${attr}: ${this.buildMsgListFromObject(object[attr])}</li></ul>`
        }
      }).join('<br>')
    },
    buildMsgListFromArray: function (object) {
      return object.map(obj => this.buildMsgListFromObject(obj)).join('<br>')
    },
    formatMessage: function (message) {
      let content = message
      if (message.response) {
        content = message.response.data
      }

      if (content instanceof Array) {
        content = this.buildMsgListFromArray(content)
      } else if (typeof content === 'object') {
        content = this.buildMsgListFromObject(content)
      }

      return content
    },
    parseLineFeeds
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label { display: inline-block; width: 150px; text-align: left; }
textarea { width: 100% }
</style>
